class SupportStatus {
  static WAITING = 1;
  static REFUSE = 2;
  static ACCEPT = 3;
  static WAITINGUNLOCK = 4;
}

export default SupportStatus;
